export default [
  {
    text: '[프로모션] 개인정보 수집·이용 동의(선택)',
    required: false,
    guideText: '[프로모션] 항목에 동의하지 않으면 참여가 불가합니다.',
    termCd: 'NOTI_3',
    type: 'term',
    path: '/terms/NOTI_3.html',
    subAgrees: [],
  },
];
